import { SCREENS, REDUX_ACTIONS, GAME_ID, NUM_STANDARD_BACKGROUNDS } from 'a/zoomBoom/data/constants';

const initState = {
  screen: SCREENS.PROGRESS,
  bgIndexes: [],
  currentBgIndex: 0,
  bgQuestionAnimationOnOff: false,
  bgRoundAnimationOnOff: false,
};

const view = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        screen: payload,
      };

    case REDUX_ACTIONS.INIT_BACKGROUNDS:
      return {
        ...state,
        bgIndexes: payload.bgIndexes,
      };

    case REDUX_ACTIONS.SET_CURRENT_BACKGROUND:
      return {
        ...state,
        currentBgIndex: state.bgIndexes[payload.level % NUM_STANDARD_BACKGROUNDS],
      };

    case REDUX_ACTIONS.SWITCH_QUESTION_BG_ANIMATION: {
      return {
        ...state,
        bgQuestionAnimationOnOff: !state.bgQuestionAnimationOnOff,
      };
    }

    case REDUX_ACTIONS.SWITCH_ROUND_BG_ANIMATION: {
      return {
        ...state,
        bgRoundAnimationOnOff: !state.bgRoundAnimationOnOff,
      };
    }

    default:
      return state;
  }
};

export default view;
